exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".diagram2-5d-2 .submit{top:-35px;right:0}.diagram2-5d-2 .simplest__text-area_c,.diagram2-5d-2 .simplest__text-area_s{height:106px}.diagram2-5d-2 .simplest__text-area_c::-webkit-scrollbar,.diagram2-5d-2 .simplest__text-area_s::-webkit-scrollbar{width:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/5/5d/diagram2/diagram2.scss
// module id = 1463
// module chunks = 0